// eslint-disable-next-line no-use-before-define
import React from 'react';
import { LoadingContainer } from './style';
export const LoadingComponent = ({ loading }) => {
    if (!loading) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(LoadingContainer, null,
        React.createElement("div", { className: "root-app_loading-container" },
            React.createElement("div", { className: "root-app_loading" },
                React.createElement("div", { className: "root-app_loading-ring" },
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null))))));
};
//# sourceMappingURL=component.js.map